import React from 'react';
import { render } from 'react-dom';

import { logger } from 'packages';
import { ProviderWithGlobalStore } from 'tradera-state/configure-store';
import SiteHeader from 'tradera-components/site-header/site-header';
import SiteFooter from 'tradera-components/site-footer/site-footer';

const headerElement = document.querySelector('[data-site-header-slim]');
const footerElement = document.querySelector('[data-site-footer]');

const MainNavigation = () => {
    if (headerElement) {
        try {
            render(
                <ProviderWithGlobalStore>
                    <SiteHeader />
                </ProviderWithGlobalStore>,
                headerElement
            );
        } catch (e) {
            logger(e);
        }
    }

    if (footerElement) {
        try {
            render(
                <ProviderWithGlobalStore>
                    <SiteFooter />
                </ProviderWithGlobalStore>,
                footerElement
            );
        } catch (e) {
            logger(e);
        }
    }
};

export { MainNavigation };
